import { apiRequest } from '../../../api/client';
import type {
  BlockUserResponse,
  ChangeUserPlanRequest,
  ChangeUserPlanResponse,
  UnblockUserResponse,
  UserAvailableLocalesRequest,
  UserAvailableLocalesResponse,
  UserListItem,
} from '../../../api/types';

// PARA-106, AC-2: список пользователей.
export async function fetchUsers(): Promise<UserListItem[]> {
  return apiRequest<UserListItem[]>('/admin/users');
}

// PARA-106, AC-3: блокировка пользователя.
export async function blockUser(userId: number): Promise<BlockUserResponse> {
  return apiRequest<BlockUserResponse>(`/admin/users/${userId}/block`, {
    method: 'POST',
  });
}

// PARA-137, AC-2: разблокировка пользователя.
export async function unblockUser(userId: number): Promise<UnblockUserResponse> {
  return apiRequest<UnblockUserResponse>(`/admin/users/${userId}/unblock`, {
    method: 'POST',
  });
}

// PARA-137, AC-4: ручная смена тарифа пользователя.
export async function changeUserPlan(
  userId: number,
  payload: ChangeUserPlanRequest,
): Promise<ChangeUserPlanResponse> {
  return apiRequest<ChangeUserPlanResponse>(`/admin/users/${userId}/change-plan`, {
    method: 'POST',
    body: payload,
  });
}

// PARA-138, AC-3: изменение доступных локалей пользователя.
export async function changeUserAvailableLocales(
  userId: number,
  payload: UserAvailableLocalesRequest,
): Promise<UserAvailableLocalesResponse> {
  return apiRequest<UserAvailableLocalesResponse>(`/admin/users/${userId}/available-locales`, {
    method: 'POST',
    body: payload,
  });
}
